<div class="scrolling-marquee-container" *ngIf="items && items.length > 0" #container>
    <div class="item-container" #marquee>
        <div (click)="itemClicked(items[currentIndex].menuItem)" class="marquee-link">
            {{items[currentIndex].message}}
        </div>
    </div>
</div>
